<template>
  <div>
    <v-container fluid :style="cssProps" class="ma-0 pa-0">
      <!-- <v-img :src="obtenerLogo" class="imageAnimate"></v-img> -->
      <v-row justify="center" class="ma-0 pa-0 py-md-5 py-lg-5 py-xl-5 mb-6">
        <v-col class="ma-0 pa-0" xs="12" sm="12" md="6" lg="6" xl="6">
          <v-card
            v-if="esDesktop"
            class="pt-3 pt-xs-3 pt-sm-4 pt-md-1 pt-lg-1 pt-xl-1 pb-5"
            elevation="6"
          >
            <router-view></router-view>
          </v-card>
          <router-view v-else class="mt-3"></router-view>
        </v-col>
      </v-row>
      <Error />
      <Exito />
    </v-container>
    <Footer></Footer>
  </div>
</template>

<script>
import Error from '@/components/compartidos/Error.vue'
import Exito from '@/components/compartidos/Exito.vue'
import Footer from '@/components/compartidos/Footer.vue'

export default {
  name: 'LayoutConfianza',
  components: { Error, Exito, Footer },
  data: () => ({
    cssProps: {
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover',
      height: '100%',
      background:
        'linear-gradient(180deg, #27AA46 0%, #0E5E1E 60%, #073A0A 100%)',
    },
  }),
  computed: {
    esDesktop() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return false
        case 'sm':
          return false
        case 'md':
          return true
        case 'lg':
          return true
        case 'xl':
          return true
        default:
          return true
      }
    },
  },
}
</script>

<style>
.container-desktop {
  background-color: #27aa46;
  height: 100%;
  background: #27aa46;
}
/* .imageAnimate {
  animation-name: example;
  animation-duration: 20s;
}
@keyframes example {
  from {
    top: 0px;
  }
  to {
    top: 700px;
  }
} */
</style>
